export const SUBSCRIBE = 'subscribe';
